module.exports = __webpack_public_path__ + "img/2.49aa3a6a.jpg";